import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';



async function autorizarModoAdmin(senha) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const body = {
      senha: senha
    };
    const dados = await api.post('/authenticate/autorizar-modo-admin/', body);
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}



export {
  autorizarModoAdmin
};
